var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"root",class:['root', { 'in-events': _vm.isNowInEvents, 'not-in-events': !_vm.isNowInEvents }]},[_c('div',{ref:"slots",staticClass:"d-none"},[_vm._t("header-left"),_vm._v(" "),_vm._t("header-center"),_vm._v(" "),_vm._t("header-right"),_vm._v(" "),_vm._t("default")],2)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22da7e8b","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Components/Calendar.vue
// module id = 662
// module chunks = 0 1